import React, { Component } from 'react';
import {Button} from 'react-bootstrap';
import BootstrapTable from 'react-bootstrap-table-next';
import ToolkitProvider from 'react-bootstrap-table2-toolkit';
import moment from 'moment';
import Auth from '../../Auth/Auth';
import { toast } from 'react-toastify';

import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';

const auth = new Auth();

function parseJwt (token) {
  
  var base64Url = token.split('.')[1];
  var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  var jsonPayload = decodeURIComponent(atob(base64).split('').map(function(c) {
      return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
  }).join(''));

  return JSON.parse(jsonPayload);
};

function DateFormatter(cell, row) {  
  return (
    <span>{moment(cell).format('YYYY-MM-DD HH:mm:ss')}</span>
  );
}

function advancedFiltered(cell) { 
  return (
    <span>{cell === 1 ? "Yes" : "No"}</span> 
  );
}

function NoResults(cell) { 
  return (
    <span>{cell === 1 ? "No" : "Yes"}</span> 
  );
} 

function RemoveFormatter(cell, row, rowIndex, formatExtraData){  
  return (
    <Button variant="link" id={row.Id} onClick={() => formatExtraData.app.removeSub(cell)}><i className="fas fa-trash text-danger"></i></Button>
  );
}

function htmlFormatter(cell){
  return (
    <span dangerouslySetInnerHTML={{ __html : cell }}></span> 
  );
}

export class TableKPI extends Component {
    constructor(props){
        super(props);

        this.state = {
            searches : []
        };
    }

    async componentDidUpdate(prevProps){      
        if(prevProps.KPIDateFilter !== this.props.KPIDateFilter){
          let d = new Date();
          let Timezone = d.getTimezoneOffset()
          let accessToken = await auth.getToken()
            fetch('/api/KPITable', {
                method : "GET",
                headers : {
                    'Authorization': "Bearer " + accessToken,
                    withCredentials : true,
                    crossDomain: true,
                    datefilter : this.props.KPIDateFilter,
                    TimeZone: Timezone
                }
            }).then(response => {
              if(response.status !== 200)
              {   
                  let payload = [{
                      status : response.status,
                      rawmsg : response.statusText,
                      cleanmsg : response.status + " was thrown with the message of " + response.statusText + " on " + response.url,
                      location: response.url,
                      timestamp : Date.now(),
                  }];
                  throw {
                      payload: payload,
                      error: new Error()
                    };
              }
              return  response.json();
          })
            .then(data => {
                  this.setState({
                    searches : data[0]
                  });
                  
            }).catch((error) => {
              window.apiError(error);
          });
        }
    }

    render(){
      const columns = [{
        dataField: 'searchId',
        text: 'searchId',
        sort: true,
        hidden: true
      },{
        dataField: 'searchQuery',
        text: 'Search Query',
        sort: true
      }, {
        dataField: 'target',
        text: 'Target Type',
        sort: true
      }, {
        dataField: 'searchTimestamp',
        text: 'Date/Time',
        sort: true,
        formatter: DateFormatter
      }, {
        dataField: 'advancedFiltered',
        text: 'Advanced?',
        sort: true,
        formatter: advancedFiltered
      }, {
        dataField: 'NoResults',
        text: 'Results Returned',
        sort: true,
        formatter: NoResults
      }, {
        dataField: 'ResponseTime',
        text: 'Response Time',
        sort: true
      }];
    
      const defaultSorted = [{
        dataField: 'searchTimestamp',
        order: 'desc'
      }];

        return (
            <div id="table-wrapper" style={{maxHeight: "75vh", overflowY: "auto"}}>
              {this.props.KPIDateFilter !== "Year" ?
                <BootstrapTable
                    bootstrap4
                    keyField="searchId"
                    data={ this.state.searches }
                    columns={ columns }
                    defaultSorted={ defaultSorted } 
                />
                :
                <div className="pt-4 text-center" style={{fontSize : "14px"}}> There is too much data to show. But you can request the information from us <a href="mailto:supportcops@ceridian.com">here</a></div>}
            </div> 
        );
    }
}
export class ContactTable extends Component {
  constructor(props){
      super(props);

      this.state = {
          searches : [],
          columns: this.props.columns,
          data: [],
          filteredNumbers: []
      };

  }

  componentDidUpdate(prevProps){
    if(this.props.data !== prevProps.data){
      this.setState({
        data : this.props.data,
        filteredNumbers : this.props.data
      });
    }
  }



  render(){
    const columns = [{
      dataField: 'Name',
      text: 'Name',
      sort: true,
    }, {
      dataField: 'PhoneNumber',
      text: 'Phone Number',
      sort: true,
      formatter: htmlFormatter
    }
  ];

    return (
        <div>         
          <ToolkitProvider
            keyField="Name"
            data={ this.state.filteredNumbers }
            columns={ columns }
          >
            {
              props => (
                <div  id="table-wrapper" style={{width: "95%", fontSize: "11.5px"}}>
                  <BootstrapTable
                    { ...props.baseProps }
                  />
                </div>
              )
            }
          </ToolkitProvider>
          {/* <Button variant="link" style={showmorebtn} onClick={() => this.showMoreNumbers()} disabled={this.state.showingMore}>show more</Button> */}
        </div>
        
    );
  }
}
export class SubsTable extends Component {
  constructor(props){
      super(props);

      this.state = {
          data: this.props.data,
          isRemoving: false
      };
  }

  componentDidUpdate(prevProps){
    if(this.props.data !== prevProps.data){
      this.setState({
        data : this.props.data
      });
    }
  }

  async removeSub(Id){
    this.setState({
      isRemoving : true
    });
    let accessToken = await auth.getToken();
    let jwt = parseJwt(localStorage.getItem("msal.idtoken"));

      fetch('/api/deactivateSearchSub', {
          method : "POST",
          headers : {
              'Authorization': "Bearer " + accessToken,
              "loggedinClientId" : jwt.oid,
              "searchsubid": Id,
              withCredentials : true,
              crossDomain: true,
          }
      }).then(response => {
        if(response.status !== 200)
        {   
            let payload = [{
                status : response.status,
                rawmsg : response.statusText,
                cleanmsg : response.status + " was thrown with the message of " + response.statusText + " on " + response.url,
                location: response.url,
                timestamp : Date.now(),
            }];
            throw {
                payload: payload,
                error: new Error()
              };
        }
        return  response.json();
    }).then(data => {
          
          let deletedSub = this.state.data.filter(data => data.Id === Id);
          let updatedArr = this.state.data.filter(data => data.Id !== Id);
          this.setState({
            data : updatedArr,
            isRemoving : false
          });
          toast.error(`DELETED Search Query - ${deletedSub[0].searchSubQuery}`, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true
          });
      }).catch((error) => {
          console.error('Error:', error);
          window.apiError(error);
      });
  }

  render(){
    const self = this;
    const columns = [{
      dataField: 'searchSubQuery',
      text: 'Query',
      sort: true,
    }, {
      dataField: 'searchSubSource',
      text: 'Source',
      sort: true,
    }, {
      dataField: 'searchSubFreq',
      text: 'Frequency',
      sort: true,
    }, {
      dataField: 'searchSubUTCTimestamp',
      text: 'Created',
      sort: true,
      formatter: DateFormatter
    }
    , {
      dataField: 'Id',
      text: 'Remove',
      sort: false,
      formatter: RemoveFormatter,
      formatExtraData: {
        app : self
      }
    }
  ];
    return (
        <div>         
          <ToolkitProvider
            keyField="searchSubQuery"
            data={ this.state.data }
            columns={ columns }
          >
            {
              props => (
                <div id="table-wrapper" style={{width: "95%", fontSize: "11.5px"}}>
                  <BootstrapTable
                    { ...props.baseProps }
                  />
                </div>
              )
            }
          </ToolkitProvider>
        </div>
        
    );
  }
}

